var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import { Translate } from "../../../../../I18N";
import { Button, Pill } from "../../../../Components/UI";
import {
  DatePropertyIcon,
  MarkdownPropertyIcon,
  NumericPropertyIcon,
  TextPropertyIcon } from "../../../../Components/CustomIcons";



const propertyIcons = {
  text: /*#__PURE__*/_jsx(TextPropertyIcon, { className: "w-4" }),
  date: /*#__PURE__*/_jsx(DatePropertyIcon, { className: "w-4" }),
  numeric: /*#__PURE__*/_jsx(NumericPropertyIcon, { className: "w-4" }),
  markdown: /*#__PURE__*/_jsx(MarkdownPropertyIcon, { className: "w-4" })
};

const columnHelper = createColumnHelper();

const ExtractorHeader = () => /*#__PURE__*/_jsx(Translate, { className: "whitespace-nowrap" }, void 0, "Extractor Name");
const PropertyHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Property");
const TemplatesHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Template(s)");
const ActionHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Action");

const PropertyCell = ({ cell }) => {
  const property = cell.getValue();
  return /*#__PURE__*/(
    _jsx("div", { className: "flex gap-2" }, void 0,
    propertyIcons[property], /*#__PURE__*/
    _jsx("p", { className: "text-gray-500" }, void 0, cell.row.original.propertyLabel)
    ));

};

const TemplatesCell = ({ cell }) => /*#__PURE__*/
_jsx("div", { className: "flex flex-wrap gap-2" }, void 0,
cell.getValue().map((templateName) => /*#__PURE__*/
_jsx("div", { className: "whitespace-nowrap" }, templateName, /*#__PURE__*/
_jsx(Pill, { color: "gray" }, void 0, templateName)
)
)
);


const LinkButton = ({ cell }) => /*#__PURE__*/
_jsx(Link, { to: `suggestions/${cell.getValue()}` }, void 0, /*#__PURE__*/
_jsx(Button, { className: "leading-4", styling: "outline" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Review")
)
);


const tableColumns = [
columnHelper.accessor('name', {
  header: ExtractorHeader,
  meta: { className: 'w-1/6' }
}),
columnHelper.accessor('propertyType', {
  header: PropertyHeader,
  cell: PropertyCell,
  meta: { className: 'w-1/6' }
}),
columnHelper.accessor('namedTemplates', {
  header: TemplatesHeader,
  enableSorting: false,
  cell: TemplatesCell,
  meta: { className: 'w-4/6' }
}),
columnHelper.accessor('_id', {
  header: ActionHeader,
  enableSorting: false,
  cell: LinkButton,
  meta: { className: 'w-0 text-center' }
})];



export { tableColumns };